<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 25 32"
  >
    <g>
      <path
        fill="none"
        stroke="#4365e2"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="2.0152"
        d="M12.253 1.008c-6.21 0-11.245 5.035-11.245 11.245v0c0 4.534 1.58 5.8 10.088 18.137 0.258 0.366 0.68 0.602 1.156 0.602s0.897-0.236 1.153-0.597l0.003-0.004c8.51-12.335 10.088-13.603 10.088-18.137 0-6.21-5.033-11.244-11.243-11.245h-0z"
      />
      <path
        fill="none"
        stroke="#4365e2"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="2.0152"
        d="M17.377 12.422c0 2.782-2.256 5.038-5.038 5.038s-5.038-2.256-5.038-5.038c0-2.782 2.256-5.038 5.038-5.038s5.038 2.256 5.038 5.038z"
      />
      <path
        fill="none"
        stroke="#4365e2"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="2.0152"
        d="M16.37 12.422c0 2.226-1.805 4.030-4.030 4.030s-4.030-1.805-4.030-4.030c0-2.226 1.805-4.030 4.030-4.030s4.030 1.805 4.030 4.030z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
